const deleteChecklistButton = {
  text: 'Eliminar checklist'
};

export default deleteChecklistButton;
